"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _expandable = require("./expandable");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/*
  Provides expandable 'context' as a render prop.
*/


var _default = function _default(props) {
  return (0, _core.jsx)(_expandable.ExpandableContext.Consumer, null, function (context) {
    return (0, _core.jsx)(_react["default"].Fragment, null, props.children(context));
  });
};

exports["default"] = _default;